var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.selectOptions,"label":"label","track-by":"id","multiple":true,"close-on-select":false},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }